import React from 'react';
import {
	Needs,
	MultiCompanyConsultation,
	CompanyType,
	KftConsultation,
	ForeignTrade,
	Income,
	InvoicesIn,
	InvoicesOut,
	Languages,
	FakeCherryProviders,
	AspProviders,
	Preferences,
	Banks,
	Accounts,
	Software,
	Industry,
	Vat,
	Taxform,
	FlowSwitch,
	//VafContactForm,
} from './newsteps/index.js';
import HorizontalLinearStepper from './components/tracker/tracker.jsx';
import Dialog from '@mui/material/Dialog';
import KnetPlusForm from '../../shared/components/knetPlusForm/knetPlus';
import axios from '../../shared/axios/axiosProxy.js';
import './searchFlow.scss';
import i18n from '../../utils/i18n.js';
import { withTranslation } from 'react-i18next';
import VacationNotice from '../../shared/components/vacationNotice/VacationNotice.jsx';
import Cookies from 'js-cookie';
import peaking1 from '../../images/peaking.png';
import peaking2 from '../../images/peaking2.png';
import peaking3 from '../../images/peaking3.png';
import peaking4 from '../../images/peaking4.png';
import rocketman from '../../images/Rocketman.png';
import blueaccountant from '../../images/BlueAccountant.png';
import { v4 as uuidv4 } from 'uuid';

//REDUX
import ACTIONS, {
	fetchAspPotentialProviders,
	fetchCherryPotentialProviders,
} from '../../redux/action';
import { connect } from 'react-redux';
import { checkStateChange } from './data/searchFlowText';
import IndustrySpecific from './newsteps/industrySpecific.jsx';
import IndustrySpecificGeneral from './newsteps/industrySpecificGeneral.jsx';
import { ensureSearchExists } from '../utils/ensureSearchExists';
import { pushFlowContextToDataLayer } from '../utils/dataLayerFlowContext';
import {
	mergeUtmIntoPayload,
	prepareAspPayload,
	resolveUtmParams,
} from '../utils/utmBootstrap';

const mapStateToProps = (state) => ({
	store: state,
	loading: state.loading,
	company_store: state.company_store,
	match_score_weights: state.match_score_weights,
	potential_providers: state.company_store.potential_providers,
});
const mapDispatchToProps = (dispatch) => ({
	addCompanyInfo: (item) => dispatch(ACTIONS.addCompanyInfo(item)),
	fetchAspPotentialProviders: (companyData, msWeights) =>
		dispatch(fetchAspPotentialProviders(companyData, msWeights)),
	fetchCherryPotentialProviders: (companyData, msWeights) =>
		dispatch(fetchCherryPotentialProviders(companyData, msWeights)),
});

class SearchFlow extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			activeStep: 0,
			reqID: '',
			cherryID: '',
			searchID: '',
			completedSteps: 0,
			kNetPlusSent: false,
			helpForm: false,
			stepData: `1 - ${new Date().toLocaleTimeString(
				i18n.t('general.countryformat'),
				{
					hour12: false,
				}
			)}`,
			viewedProviders: [],
			utmzz: Cookies.get('__utmzz') || null,
			utm_source: '',
			utm_medium: '',
			utm_campaign: '',
			utm_content: '',
			utm_term: '',
			gclid: '',
			dclid: '',
			vacatiOn: false,
			bookkeepie_id: Cookies.get('bookkeepie_id') || null,
		};
	}

	dataLayerUpdate(stepData, event) {
		window.dataLayer.push({
			event: event,
			step: stepData,
			event_category: 'aspflow',
		});
	}

	dataLayerVersionUpdate() {
		pushFlowContextToDataLayer({
			version: 'A',
			flow: 'aspflow',
			company_store: this.props.company_store,
		});
	}

	bkIdDataLayerUpdate(stepData, event) {
		window.dataLayer.push({
			event: event,
			bookkeepie_id: stepData,
			event_category: 'aspflow',
		});
	}

	componentDidMount() {
		console.log('[SearchFlow A/B] rendering SearchFlow version A');
		let bkID = Cookies.get('bookkeepie_id');
		const { company_store, addCompanyInfo } = this.props;

		// Sync UTMs from Redux (populated by CompanyLayout UTM bootstrap)
		if (company_store.utm_source || company_store.utm_medium || company_store.utm_campaign) {
			this.setState({
				utm_source: company_store.utm_source || '',
				utm_medium: company_store.utm_medium || '',
				utm_campaign: company_store.utm_campaign || '',
				utm_content: company_store.utm_content || '',
				utm_term: company_store.utm_term || '',
				gclid: company_store.gclid || '',
				dclid: company_store.dclid || '',
			});
		}

		// Capture referrer immediately if not already in Redux (before creating search)
		const currentSourceUrl = company_store.sourceUrl;
		if (!currentSourceUrl) {
			const referrer = document.referrer || '';
			if (referrer) {
				addCompanyInfo({
					id: 'sourceUrl',
					data: referrer,
					stateObject: 'company_store',
				});
				if (window.dataLayer) {
					window.dataLayer.push({
						event: 'sourceUrl_captured',
						sourceUrl: referrer,
					});
				}
			}
		}

		addCompanyInfo({
			id: 'abVersion',
			data: 'A',
			stateObject: 'company_store',
		});

		// Ensure search exists (creates only if company_store.searchID empty; uses UTMs from Redux)
		ensureSearchExists({
			flowType: 'ASP',
			abVersion: 'A',
			company_store,
			addCompanyInfo,
			step: this.state.activeStep + 1,
			stepData: this.state.stepData,
		}).then((searchID) => {
			if (searchID) {
				this.setState({ searchID });
			}
		});

		const selectedSP = localStorage.getItem('selectedSP');
		selectedSP &&
			addCompanyInfo({
				id: 'spSelectedFromList',
				data: selectedSP,
				stateObject: 'company_store',
			});
		this.dataLayerUpdate(0, 'sf_step_changed');
		this.dataLayerVersionUpdate();
		let cookie = document.cookie;
		if (!cookie.includes('reqsent')) {
			document.cookie = 'reqsent=false';
		}
		if (!bkID) {
			bkID = uuidv4();
			this.setState({ bookkeepie_id: bkID });
			Cookies.set('bookkeepie_id', bkID, { expires: 90 });
			this.props.addCompanyInfo({
				id: 'searchUser',
				data: bkID,
				stateObject: 'company_store',
			});
			axios
				.post(
					`/api/searchUser`,
					{
						userID: bkID,
						searches: [],
						reqs: [],
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then((response) => {
					console.log('AXIOS RESPONSE: ', response);
				})
				.catch((error) => {
					console.log('AXIOS ERROR: ', error.response.data);
				});
		} else {
			this.props.addCompanyInfo({
				id: 'searchUser',
				data: bkID,
				stateObject: 'company_store',
			});
		}
		this.bkIdDataLayerUpdate(bkID, 'sf_step_bookkeepie_id');

		const urlParams = new URLSearchParams(window.location.search);
		const urlExisting = urlParams.get('existing');
		const urlCompanytype = urlParams.get('companytype');

		if (urlExisting === 'true') {
			this.props.addCompanyInfo({
				id: 'anwser',
				data: 'existing',
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'newlyfounded',
				data: false,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'legalentityfounding',
				data: false,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'taxconsultingcomplex',
				data: false,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'taxconsultingsimple',
				data: false,
				stateObject: 'company_store',
			});
			this.setState({
				activeStep: 2,
			});
		}
		if (urlExisting === 'false') {
			// Coming from searchflowb's "Még nincs" answer — that already implies the
			// Needs step's (step 0) three questions, so default them to what a "founding,
			// one company, ASAP" user would have picked there (matches Needs.jsx's own
			// 'founding' RadioGroup branch + DeadlinePicker's "ASAP" option), even though
			// the flow lands directly on CompanyType (step 1) and may never show step 0.
			this.props.addCompanyInfo({
				id: 'answer',
				data: 'founding',
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'anwser',
				data: 'founding',
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'accounting',
				data: false,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'newlyfounded',
				data: true,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'legalentityfounding',
				data: true,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'taxconsultingcomplex',
				data: false,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'taxconsultingsimple',
				data: false,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'multiplecompany',
				data: 'singlecompany',
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'startingdate',
				data: new Date().setDate(new Date().getDate()),
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'chosendate',
				data: 'asap',
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'deadline',
				data: '0',
				stateObject: 'company_store',
			});
			this.setState({
				activeStep: 2,
			});
		}
		if (urlCompanytype === 'bt' || urlCompanytype === 'kft') {
			this.props.addCompanyInfo({
				id: 'anwser',
				data: 'founding',
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'newlyfounded',
				data: true,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'legalentityfounding',
				data: true,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'companytype',
				data: urlCompanytype,
				stateObject: 'company_store',
			});
			this.setState({
				activeStep: 4,
			});
		}
	}

	componentDidUpdate(_prevProps, prevState) {
		// Update search with sourceUrl if it becomes available after search was created
		if (
			this.state.searchID &&
			this.props.company_store.sourceUrl &&
			!_prevProps.company_store.sourceUrl
		) {
			console.log(
				'[sourceUrl] sourceUrl became available, updating search:',
				this.props.company_store.sourceUrl
			);
			axios
				.patch(
					`/api/search/${this.state.searchID}`,
					{
						sourceUrl: this.props.company_store.sourceUrl,
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then((response) => {
					console.log(
						'[sourceUrl] Search updated with sourceUrl in componentDidUpdate'
					);
				})
				.catch((error) => {
					console.error(
						'[sourceUrl] Error updating search with sourceUrl in componentDidUpdate:',
						error.response?.data || error.message
					);
				});
		}

		this.handleSearchUpdate(prevState.activeStep);
		let bkID = Cookies.get('bookkeepie_id');
		if (bkID) {
			let searchList = [];
			axios
				.get(`/api/searchUser/${bkID}`, {
					headers: {
						'Content-Type': 'application/json',
					},
				})
				.then((response) => {
					searchList = response.data.searchUser.searches.filter(
						(value) => value !== null
					);
					const sid = this.state.searchID;
					const sidStr = sid && String(sid).trim();
					if (sidStr && !searchList.some((s) => String(s) === sidStr)) {
						searchList.push(sidStr);
						let uniques = [
							...new Set(
								searchList.filter((item) => String(item).trim() !== '')
							),
						];
						axios.patch(
							`/api/searchUser/${bkID}`,
							{ searches: uniques },
							{
								headers: {
									'Content-Type': 'application/json',
								},
							}
						);
					}
				})
				.catch((error) => {
					console.log(
						'AXIOS ERROR COMPUPDATE: ',
						error.response || error.message
					);
					console.log('Bookkeepie ID:', bkID);
				});
		}
		if (
			this.state.completedSteps >= 20 &&
			checkStateChange(_prevProps.company_store, this.props.company_store) ===
				true
			// && this.checkServices() === true
		) {
			this.props.fetchAspPotentialProviders(
				this.props.company_store,
				this.props.match_score_weights
			);
		}
		if (
			this.state.completedSteps >= 21 &&
			this.state.reqID.length > 0 &&
			checkStateChange(_prevProps.company_store, this.props.company_store)
			// && this.checkServices() === true
		) {
			//this.setState({ reqID: '' });
			this.props.addCompanyInfo({
				id: 'selected_providers',
				data: [],
				stateObject: 'company_store',
			});
		}
	}

	handleNext = (increment = 1) => {
		//console.log(increment, typeof increment, 'INCREMENT');
		if (this.state.activeStep <= 21) {
			if (this.state.searchID === '') {
				this.submitSearchData();
			}
			this.setState({
				activeStep: this.state.activeStep + increment,
			});
			this.dataLayerUpdate(
				this.state.activeStep + increment,
				'sf_step_changed'
			);
			if (this.state.completedSteps < this.state.activeStep) {
				this.setState({
					completedSteps: this.state.completedSteps + increment,
				});
			}
		}

		// Check for UTM referral when moving from step 0 to step 1
		if (this.state.activeStep === 0 && increment === 1) {
			const utmMedium = this.props.company_store.utm_medium;
			const utmCampaign = this.props.company_store.utm_campaign;

			if (utmMedium === 'referral' && utmCampaign) {
				console.log(
					'UTM referral detected on step transition, setting discount code:',
					utmCampaign
				);
				this.props.addCompanyInfo({
					id: 'discountCode',
					data: utmCampaign,
					stateObject: 'company_store',
				});
			}
		}

		this.props.addCompanyInfo({
			id: 'activeStep',
			data: this.state.activeStep,
			stateObject: 'company_store',
		});
		console.log(this.props.company_store, 'KOMPANI');
		window.scrollTo(0, 0);
	};
	handleBack = (decr = 1) => {
		if (this.state.activeStep !== 0) {
			this.setState({ activeStep: this.state.activeStep - decr });
		}
		this.props.addCompanyInfo({
			id: 'activeStep',
			data: this.state.activeStep,
			stateObject: 'company_store',
		});
		window.scrollTo(0, 0);
	};
	handleTracker = (step) => {
		this.setState({ activeStep: step });
	};
	handleKnetPlusContact = () => {
		this.setState({ kNetPlusSent: true });
	};
	openHelpForm = () => {
		this.setState({ helpForm: true });
	};
	closeHelpForm = () => {
		this.setState({ helpForm: false });
	};
	createAspRequest = (companyData) => {
		let data = prepareAspPayload(companyData, {
			searchID:
				this.state.searchID ||
				this.props.company_store?.searchID ||
				companyData.searchID ||
				'',
			abVersion: this.props.company_store.abVersion || 'A',
			sourceUrl: this.props.company_store.sourceUrl || '',
		});
		console.log(
			'[sourceUrl] Creating ASP request with sourceUrl:',
			data.sourceUrl
		);
		if (data.noofemployees === '') {
			data.noofemployees = 0;
		}
		if (data.incominginvoices === '') {
			data.incominginvoices = 0;
		}
		if (data.outgoinginvoices === '') {
			data.outgoinginvoices = 0;
		}
		axios
			.post(`/api/aspreq`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				sessionStorage.setItem('reqEmail', data.email);
				const reqID = response.data.result._id;
				const searchID = response.data.searchID || this.state.searchID;

				console.log('ASP Request created successfully:', {
					reqID: reqID,
					searchID: searchID,
					backendSearchID: response.data.searchID,
					existingSearchID: this.state.searchID,
				});

				// Update state with callback to ensure it's set before next call
				this.setState({ reqID: reqID }, () => {
					this.props.addCompanyInfo({
						id: 'reqID',
						data: reqID,
						stateObject: 'company_store',
					});

					// Update searchID if backend created/returned one
					if (response.data.searchID && !this.state.searchID) {
						this.setState({ searchID: response.data.searchID }, () => {
							this.props.addCompanyInfo({
								id: 'searchID',
								data: response.data.searchID,
								stateObject: 'company_store',
							});
							this.handleSearchRequestSent(reqID);
						});
					} else {
						this.handleSearchRequestSent(reqID);
					}
				});
			})
			.catch((error) => {
				console.error('Failed to create ASP request:', {
					error: error.response?.data || error.message,
					searchID: this.state.searchID,
					email: data.email,
				});
			});
	};
	requestCallBack = (companyData) => {
		const data = prepareAspPayload(companyData);
		axios
			.post(`/api/aspreq/requestcallback/new`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response);
				this.setState({ reqID: response.data.result._id });
				this.props.addCompanyInfo({
					id: 'reqID',
					data: response.data.result._id,
					stateObject: 'company_store',
				});
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};

	createCherryRequest = (companyData) => {
		let data = Object.assign({}, companyData);
		let ppArray = [];
		for (var i in data.potential_providers) {
			ppArray.push(data.potential_providers[i]);
		}
		data.potential_providers = ppArray;

		// Use state first, then Redux so we send searchID even if state wasn't synced yet
		data.searchID =
			this.state.searchID ||
			this.props.company_store?.searchID ||
			data.searchID ||
			'';
		if (data.noofemployees === '') {
			data.noofemployees = 0;
		}
		if (data.incominginvoices === '') {
			data.incominginvoices = 0;
		}
		if (data.outgoinginvoices === '') {
			data.outgoinginvoices = 0;
		}

		//console.log(data, 'CHERRY REQ DATA');
		//data.lang = this.props.company_store.chosenLanguage;

		axios
			.post(`/api/request`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				const reqID = response.data.result._id;
				const cherryID = reqID;
				const searchID = response.data.searchID || this.state.searchID;

				console.log('Cherry Request created successfully:', {
					reqID: reqID,
					cherryID: cherryID,
					searchID: searchID,
					backendSearchID: response.data.searchID,
					existingSearchID: this.state.searchID,
				});

				this.setState({ cherryID: cherryID }, () => {
					this.props.addCompanyInfo({
						id: 'cherryID',
						data: cherryID,
						stateObject: 'company_store',
					});

					if (this.state.reqID === '' || !this.state.reqID) {
						this.setState({ reqID: reqID }, () => {
							this.props.addCompanyInfo({
								id: 'reqID',
								data: reqID,
								stateObject: 'company_store',
							});

							// Update searchID if backend created/returned one
							if (response.data.searchID && !this.state.searchID) {
								this.setState({ searchID: response.data.searchID }, () => {
									this.props.addCompanyInfo({
										id: 'searchID',
										data: response.data.searchID,
										stateObject: 'company_store',
									});
									this.handleSearchRequestSent(reqID);
								});
							} else {
								this.handleSearchRequestSent(reqID);
							}
						});
					} else {
						// Update searchID if backend created/returned one
						if (response.data.searchID && !this.state.searchID) {
							this.setState({ searchID: response.data.searchID }, () => {
								this.props.addCompanyInfo({
									id: 'searchID',
									data: response.data.searchID,
									stateObject: 'company_store',
								});
								this.handleSearchRequestSent(reqID);
							});
						} else {
							this.handleSearchRequestSent(reqID);
						}
					}
				});
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error);
			});
	};
	updateRequest = (companyData, reqID = this.state.reqID) => {
		let data = Object.assign({}, companyData);
		if (data.potential_providers) {
			delete data.potential_providers;
		}
		if (data.noofemployees === '') {
			data.noofemployees = 0;
		}
		//console.log(data, this.state.reqID, 'DATA AND REQID IN UPDATE');
		let dataToSend = { reqData: data, reqID: reqID };
		axios
			.patch(`/api/request/addprov`, dataToSend, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};
	updateFakeCherryRequest = (companyData) => {
		let data = Object.assign({}, companyData);
		// if (data.potential_providers) {
		//   delete data.potential_providers;
		// }
		if (data.noofemployees === '') {
			data.noofemployees = 0;
		}
		//console.log(this.state.reqID, 'REQID');
		let dataToSend = { reqData: data, reqID: this.state.reqID };
		//console.log(dataToSend, 'DATA AND REQID IN UPDATE');
		axios
			.patch(`/api/aspreq/addprov/addfakecherry`, dataToSend, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};

	handleSearchRequestSent = (reqID = null) => {
		const timeStamp = this.state.stepData.concat(
			` Req sent - ${new Date().toLocaleTimeString(
				i18n.t('general.countryformat'),
				{
					hour12: false,
				}
			)}`
		);
		const actualReqID = reqID || this.state.reqID;
		this.setState({ stepData: timeStamp }, () =>
			this.updateSearchData(timeStamp, actualReqID)
		);
		// Backend already updates rfpsent and reqID, no need for frontend update
	};

	submitSearchData = () => {
		const cs = this.props.company_store;
		// Sync from Redux if ensureSearchExists already set it
		if (!this.state.searchID && cs.searchID) {
			this.setState({ searchID: cs.searchID });
			return;
		}
		// Delegate to ensureSearchExists to avoid duplicate creation
		if (!this.state.searchID && !cs.searchID) {
			ensureSearchExists({
				flowType: 'ASP',
				abVersion: cs.abVersion || 'A',
				company_store: cs,
				addCompanyInfo: this.props.addCompanyInfo,
				step: this.state.activeStep + 1,
				stepData: this.state.stepData,
			}).then((searchID) => {
				if (searchID) this.setState({ searchID });
			});
			return;
		}
	};
	updateSearchData = (time, reqID = null) => {
		// Only update search when we have a valid searchID (state or Redux)
		const effectiveSearchID =
			this.state.searchID || this.props.company_store?.searchID;
		if (
			!effectiveSearchID ||
			effectiveSearchID === 'undefined' ||
			effectiveSearchID === 'null'
		) {
			console.warn(
				'[updateSearchData] Skipping PATCH - no valid searchID (backend will have set reqID on createAspRequest)'
			);
			return;
		}

		let data = { ...this.props.company_store };
		const timeValue = time ?? this.state.stepData;
		console.log(data, 'EEEEE');
		data.lang = this.props.company_store.chosenLanguage;
		if (!this.state.requestSent) {
			data.step = this.state.activeStep + 1;
		}
		data.time = timeValue;
		// Only include reqID if we have a valid value (backend will set it anyway)
		// Don't send empty string which might overwrite backend value
		const actualReqID = reqID || this.state.reqID;
		if (
			actualReqID &&
			actualReqID !== '' &&
			actualReqID !== null &&
			actualReqID !== undefined
		) {
			data.reqID = actualReqID;
		}
		mergeUtmIntoPayload(
			data,
			this.state,
			resolveUtmParams({
				company_store: this.props.company_store,
				componentState: this.state,
			})
		);
		data.abVersion = this.props.company_store.abVersion || 'A';
		data.sourceUrl = this.props.company_store.sourceUrl || '';
		console.log(
			'[sourceUrl] Updating search data with sourceUrl:',
			data.sourceUrl
		);
		data.distanceWeight = this.props.store.match_score_weights.distanceWeight;
		data.priceWeight = this.props.store.match_score_weights.priceWeight;
		data.reviewWeight = this.props.store.match_score_weights.reviewWeight;
		data.phoneWeight = this.props.store.match_score_weights.phoneWeight;
		data.availabilityWeight =
			this.props.store.match_score_weights.availabilityWeight;
		data.experienceWeight =
			this.props.store.match_score_weights.experienceWeight;
		data.liabilityInsWeight =
			this.props.store.match_score_weights.liabilityInsWeight;
		data.badgeWeight = this.props.store.match_score_weights.badgeWeight;
		console.log(this.props.potential_providers, 'EEEEE');
		if (
			this.props.potential_providers !== undefined &&
			this.props.potential_providers.constructor === Object &&
			this.props.potential_providers.some((e) => e.length !== 0)
		) {
			let rPCounter = 0;
			this.props.potential_providers.forEach((e) => {
				//console.log(e, 'EEEEE');
				rPCounter += e.length;
			});

			data.returnedProviders = rPCounter;
			let tempArray = [[], [], []];
			for (let i in this.props.potential_providers) {
				for (let j in i) {
					tempArray[i].push(this.props.potential_providers[i][j].companyname);
				}
			}
			data.providers = tempArray;
		}
		axios
			.patch(`/api/search/${effectiveSearchID}`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response.statusText);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};
	handleSearchUpdate = (prevStep) => {
		if (this.state.activeStep !== prevStep) {
			let timeString = this.state.stepData.concat(
				`, ${this.state.activeStep + 1} - ${new Date().toLocaleTimeString(
					'hu-HU',
					{
						hour12: false,
					}
				)}`
			);
			this.setState({
				stepData: timeString,
			});
			if (this.state.activeStep !== 2) {
				this.updateSearchData(timeString);
			}
		}
		if (prevStep === 'tableUpdate') {
			this.updateSearchData(this.state.stepData);
		}
	};
	updateViewedProviders = (provider) => {
		let data = {};
		let viewedProviders = this.state.viewedProviders;
		if (viewedProviders.length === 0) {
			viewedProviders.push(provider);
		}
		if (
			viewedProviders.length > 0 &&
			!viewedProviders.some((item) => item.name === provider.name)
		) {
			viewedProviders.push(provider);
		}
		data.viewedProviders = viewedProviders;
		this.setState({
			viewedProviders: viewedProviders,
		});
		const effectiveSearchID =
			this.state.searchID || this.props.company_store?.searchID;
		if (
			!effectiveSearchID ||
			effectiveSearchID === 'undefined' ||
			effectiveSearchID === 'null'
		) {
			return;
		}
		axios
			.patch(`/api/search/${effectiveSearchID}`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};

	stepperCounter = {
		0: 0,
		1: 1,
		2: 1,
		3: 1,
		4: 1,
		5: 1,
		6: 1,
		7: 1,
		8: 1,
		9: 1,
		10: 1,
		11: 1,
		12: 2,
		13: 2,
		14: 2,
		15: 2,
		16: 2,
		17: 3,
		18: 3,
		19: 3,
	};

	headerText = {
		0: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext1')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext1a')}</p>
			</div>
		),
		1: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		2: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		3: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		4: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		5: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		6: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		7: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		8: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		9: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		10: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		11: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		12: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext3')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext3a')}</p>
			</div>
		),
		13: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext3')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext3a')}</p>
			</div>
		),
		14: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext3')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext3a')}</p>
			</div>
		),
		15: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext3')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext3a')}</p>
			</div>
		),
		16: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext3')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext3a')}</p>
			</div>
		),
		17: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext4')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext4a')}</p>
			</div>
		),
		18: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext4')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext4a')}</p>
			</div>
		),
		19: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext4')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext4a')}</p>
			</div>
		),
		20: null,
		21: null,
	};
	imageSource = {
		0: peaking1,
		1: peaking2,
		2: peaking2,
		3: peaking2,
		4: peaking2,
		5: peaking2,
		6: peaking2,
		7: peaking2,
		8: peaking2,
		9: peaking2,
		10: peaking2,
		11: peaking2,
		12: peaking3,
		13: peaking3,
		14: peaking3,
		15: peaking3,
		16: peaking3,
		17: peaking4,
		18: peaking4,
		19: peaking4,
		20: null,
		21: null,
	};

	getStepContent = (step) => {
		switch (step) {
			case 0: {
				return (
					<Needs
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}

			case 1: {
				return (
					<MultiCompanyConsultation
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 2: {
				return (
					<CompanyType
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 3: {
				return (
					<KftConsultation
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 4: {
				return (
					<Taxform
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 5: {
				return (
					<Vat
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 6: {
				return (
					<Industry
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 7: {
				return (
					<IndustrySpecific
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 8: {
				return (
					<Banks
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 9: {
				return (
					<Accounts
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 10: {
				return (
					<Software
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 11: {
				return (
					<ForeignTrade
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 12: {
				return (
					<Income
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 13: {
				return (
					<InvoicesIn
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 14: {
				return (
					<InvoicesOut
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 15: {
				return (
					<IndustrySpecificGeneral
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			// case 16: {
			// 	return (
			// 		<IndustrySpecificExtra
			// 			handleNext={this.handleNext}
			// 			handleBack={this.handleBack}
			// 			openHelpForm={this.openHelpForm}
			// 		/>
			// 	);
			// }
			case 17: {
				return (
					<Languages
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 18: {
				return (
					<Preferences
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
						fetchAspPotentialProviders={this.props.fetchAspPotentialProviders}
						fetchCherryPotentialProviders={
							this.props.fetchCherryPotentialProviders
						}
					/>
				);
			}
			case 19: {
				return (
					<FlowSwitch
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
						fetchAspPotentialProviders={this.props.fetchAspPotentialProviders}
						fetchCherryPotentialProviders={
							this.props.fetchCherryPotentialProviders
						}
					/>
				);
			}
			case 20: {
				return (
					<AspProviders
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						createAspRequest={this.createAspRequest}
						updateRequest={this.updateRequest}
						reqID={this.state.reqID}
						openHelpForm={this.openHelpForm}
						updateViewedProviders={this.updateViewedProviders}
						handleSearchUpdate={this.handleSearchUpdate}
						discountCode={this.state.discountCode}
						requestCallBack={this.requestCallBack}
					/>
				);
			}
			case 21: {
				return (
					<FakeCherryProviders
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						createAspRequest={this.createAspRequest}
						createRequest={this.createCherryRequest}
						updateRequest={this.updateRequest}
						updateFakeCherryRequest={this.updateFakeCherryRequest}
						reqID={this.state.reqID}
						openHelpForm={this.openHelpForm}
						updateViewedProviders={this.updateViewedProviders}
						handleSearchUpdate={this.handleSearchUpdate}
						discountCode={this.state.discountCode}
						fetchAspPotentialProviders={this.props.fetchAspPotentialProviders}
						requestCallBack={this.requestCallBack}
					/>
				);
			}
			default:
				return i18n.t('general.notfound');
		}
	};

	render() {
		return (
			<>
				<VacationNotice />
				<div className={'SFContainer'}>
					<Dialog
						open={this.props.company_store.idk || this.state.helpForm}
						onClose={() => {
							this.props.company_store.idk === true
								? this.props.addCompanyInfo({
										id: 'idk',
										data: false,
										stateObject: 'company_store',
								  })
								: this.setState({ helpForm: false });
						}}
						handleClose={() => {
							this.props.company_store.idk === true
								? this.props.addCompanyInfo({
										id: 'idk',
										data: false,
										stateObject: 'company_store',
								  })
								: this.setState({ helpForm: false });
						}}>
						<KnetPlusForm
							kNetPlusSent={this.state.kNetPlusSent}
							handleKnetPlusContact={this.handleKnetPlusContact}
							closeHelpForm={this.closeHelpForm}
							helpForm={this.state.helpForm}
						/>
					</Dialog>
					{this.state.activeStep !== 20 && this.state.activeStep !== 21 && (
						<div className="SFLeftInfoArea">
							<img src={rocketman} alt="RocketMan" className="rocketman" />
						</div>
					)}
					<div
						className={`${
							this.state.activeStep !== 20 && this.state.activeStep !== 21
								? 'SFContentArea'
								: 'SFOfferArea'
						}`}>
						{this.state.activeStep !== 20 && this.state.activeStep !== 21 && (
							<div className="SFContentHeader">
								<div className="stepperContainer">
									<HorizontalLinearStepper
										activeStep={this.stepperCounter[this.state.activeStep]}
									/>
								</div>
								<div>{this.headerText[this.state.activeStep]}</div>

								<div>
									<img
										className="headerImg"
										alt="header"
										src={this.imageSource[this.state.activeStep]}
									/>
								</div>
							</div>
						)}

						{this.getStepContent(this.state.activeStep)}
					</div>
					{this.state.activeStep !== 20 && this.state.activeStep !== 21 && (
						<div className="SFRightInfoArea">
							<img
								src={blueaccountant}
								alt="Accountant lady"
								className="blueaccountant"
							/>
						</div>
					)}
					<div style={{ display: 'none' }}>
						<p>Hidden fields</p>
						<input type="hidden" />
						<br />
						<input type="text" id="utm_source" name="utm_source" />
						<br />
						<input type="text" id="utm_medium" name="utm_medium" />
						<br />
						<input type="text" id="utm_campaign" name="utm_campaign" />
						<br />
						<input type="text" id="utm_content" name="utm_content" />
						<br />
						<input type="text" id="utm_term" name="utm_term" />
						<br />
						<input type="text" id="gclid" name="gclid" />
						<br />
						<input type="text" id="dclid" name="dclid" />
						<br />
					</div>
				</div>
			</>
		);
	}
}

export default withTranslation()(
	connect(mapStateToProps, mapDispatchToProps)(SearchFlow)
);
